import type { Feed, FeedResponse } from '@knocklabs/client'
import type { JsonObject } from '@seen/core/json'

// Client-only options the SDK strips before it builds a feed request. Mirrored
// here so a store-free read is scoped exactly like the feed it describes.
const CLIENT_ONLY_OPTIONS = [
  '__loadingType',
  '__fetchSource',
  '__experimentalCrossBrowserUpdates',
  'auto_manage_socket_connection',
  'auto_manage_socket_connection_delay',
] as const

// Reads a feed page without touching feedClient.store. The store-free path
// matters: feed.fetch() returns early whenever any request is already in
// flight, so a read routed through it would be silently dropped exactly when
// the inbox is busiest. Overrides win over the feed's own options.
export async function requestInboxFeed(
  feedClient: Feed,
  overrides: JsonObject
): Promise<FeedResponse | undefined> {
  const userId = feedClient.knock.userId
  if (!userId) {
    return undefined
  }
  const params: JsonObject = {
    ...feedClient.defaultOptions,
    ...overrides,
  }
  for (const option of CLIENT_ONLY_OPTIONS) {
    delete params[option]
  }
  const result = await feedClient.knock
    .client()
    .makeRequest({
      method: 'GET',
      url: `/v1/users/${userId}/feeds/${feedClient.feedId}`,
      params,
    })
    .catch(() => undefined)
  if (!result || result.statusCode === 'error' || !result.body) {
    return undefined
  }
  return result.body as FeedResponse
}
